export default __webpack_public_path__ + "img/bg-yellow.jpg?a1ca";